import React from 'react';

import styles from './DateEvent.module.css';

interface IDateEvent {
  name: string;
  date: string | null;
}

const DateEvent = ({ name, date }: IDateEvent) => (
  <div className={styles.container}>
    <div className={styles.name}>{name}</div>
    <div className={styles.date}>{date}</div>
  </div>
);

export default DateEvent;
